import { Add } from "@mui/icons-material";
import { Box, Button, Container, Tab } from "@mui/material";
import React, { useState } from "react";
import HistoryMerchant from "./HistoryMerchant";
import PendingMerchant from "./PendingMerchant";
import ViewMerchant from "./ViewMerchant";
import CreateDialog from "./Dialogs/CreateDialog";
import HeaderHelpPage from "../HeaderHelpPage";
import { writeLog } from "../../services/services";
import TabsMenu from "../TabsMenu";
import { TabPanel } from "@mui/lab";
import { styles } from "../../utils/styles";

const MerchantSwitchView = ({ userRole }) => {
  const [selectedView, setSelectedView] = useState("All");
  const [createDialog, setCreateDialog] = useState(false);

  const handleChange = (event, value) => {
    setSelectedView(value);
  };
  return (
    <Container>
      <HeaderHelpPage title="Merchant" description="This page manage Merchant List on our system." />
      <TabsMenu value={selectedView} onChange={handleChange}>
        <Tab label="All" value="All" />
        <Tab label="Pending" value="Pending" />
        <Tab label="History" value="History" />
        {userRole.includes("Add") && selectedView === "All" && (
          <Box>
            <Button
              variant="contained"
              onClick={() => {
                writeLog('[Info] - Click button [Add new merchant - show popup Add New Merchant');
                setCreateDialog(true);
              }}
              startIcon={<Add />}
              sx={{ ...styles.customButton }}
            >
              Add New Merchant
            </Button>
          </Box>
        )}
        
        <TabPanel value="All">
          <ViewMerchant userRole={userRole} />
        </TabPanel>
        <TabPanel value="Pending">
          <PendingMerchant userRole={userRole} />
        </TabPanel>
        <TabPanel value="History">
          <HistoryMerchant userRole={userRole} />
        </TabPanel>
      </TabsMenu>

      <CreateDialog
        open={createDialog}
        onClose={() => setCreateDialog(false)}
      />
    </Container>
  );
};

export default MerchantSwitchView;
